import { createSlice } from '@reduxjs/toolkit'
import { inputSearch } from 'constants/configLocalStorage'
import { getParamsUrl } from 'Helpers/helpFunction'

const stock = getParamsUrl(window.location.search)
let ticker = null
if (stock?.[0] === 'stock') {
  ticker = stock?.[1].toUpperCase()
}

export const StocksAnalysisStore = createSlice({
  name: 'StocksAnalysisStore',
  initialState: {
    showModal: false,
    tabActive: 'tong-quan',
    tabActiveMobile: '',
    inputSearch: ticker || localStorage.getItem(inputSearch) || 'DSC',
    priceStockAnalysis: {
    },
  },
  reducers: {
    setShowModal: (state: any) => {
      state.showModal = !state.showModal
    },
    changeTabActive: (state: any, actions: any) => {
      state.tabActive = actions?.payload?.tabActive
    },
    changeTabActiveMobile: (state: any, actions: any) => {
      if (actions?.payload?.tabActiveMobile !== state.tabActiveMobile) {
        state.tabActiveMobile = actions?.payload?.tabActiveMobile
      } else {
        state.tabActiveMobile = ''
      }
    },
    changeTabActiveMobileV2: (state: any, actions: any) => {
      state.tabActiveMobile = actions?.payload?.tabActiveMobile
    },
    changeInputSearchStock: (state: any, actions: any) => {
      localStorage.setItem(inputSearch, actions?.payload?.value)
      state.inputSearch = actions?.payload?.value
    },
    setPriceStockAnalysis: (state: any, actions: any) => {
      state.priceStockAnalysis = { ...actions?.payload }
    }
  }
})

// Action creators are generated for each case reducer function
export const { setShowModal, changeTabActive, changeTabActiveMobile, changeTabActiveMobileV2,
  changeInputSearchStock, setPriceStockAnalysis } = StocksAnalysisStore.actions

export default StocksAnalysisStore.reducer